import React from 'react';
import PaidIcon from '@mui/icons-material/Paid';
import Tooltip from '../../../components/GlobalComponents/ToolTipComponent';
import { COLORS } from '../../../utils/Application_Constants';
import { getInvoicePriorityTooltipTitle } from '../../Utils/ExpenseUtil';

export default function InvoicePriorityIndicator({
    isInvoicePriority,
    timelineToInvoiceExpense,
    fontSize = 'medium',
}) {
    if (!isInvoicePriority) {
        return null;
    }

    const title = getInvoicePriorityTooltipTitle(timelineToInvoiceExpense);
    const icon = <PaidIcon fontSize={fontSize} style={{ color: COLORS.LT_JOURNEY }} />;

    if (!title) {
        return icon;
    }

    return <Tooltip title={title}>{icon}</Tooltip>;
}
